/* registericons.js */

"use strict";
const IconRegistry = require("@gluenetworks/icon_registry").getInstance();

IconRegistry.registerIcon("branding.dataExport", require("./rawicons/data_export.icon.png.js"));
IconRegistry.registerIcon("branding.deviceManager", require("./rawicons/device_manager.icon.png.js"));
IconRegistry.registerIcon("branding.modelEditor", require("./rawicons/model_editor.icon.png.js"));
IconRegistry.registerIcon("branding.workTriggers", require("./rawicons/work_triggers.icon.png.js"));
IconRegistry.registerIcon("branding.workflowExplorer", require("./rawicons/workflow_explorer.icon.png.js"));
IconRegistry.registerIcon("branding.configDrift", require("./rawicons/config_drift.icon.png.js"));
IconRegistry.registerIcon("branding.fileServer", require("./rawicons/file_server.icon.png.js"));
IconRegistry.registerIcon("branding.osManager", require("./rawicons/os_manager.icon.png.js"));
